/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Permission_Filter_AllowedInputs */

const fr_permission_filter_allowed = /** @type {(inputs: Permission_Filter_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autorisé`)
};

/**

* @param {Permission_Filter_AllowedInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const permission_filter_allowed = /** @type {((inputs?: Permission_Filter_AllowedInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Permission_Filter_AllowedInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_permission_filter_allowed(inputs)
});